/** 這隻檔案為自動生成，請勿更動 */
import { type AxiosRequestConfig } from 'axios'
import { AgentAPI, usePage, useSWR, cancelRequest } from '@apis'
export { usePage, useSWR, cancelRequest }

/**
 * 取得启用中所有币别
 * @see https://api-doc.cxsport.net/#/view/r2jZNM2G
 */
export const reqApiAgentCurrencyList = async function (this: AxiosRequestConfig | void): Promise<OK_API_AGENT_CURRENCY_LIST.RES> {
  return (this?.instance || AgentAPI).get(`/api/agent/currency/list`, this || undefined)
}

/**
 * 根据条件获取所有玩法组合
 * @see https://api-doc.cxsport.net/#/view/7zLODlXQ
 */
export const reqApiAgentPlayQuotaComUserMylist = async function (this: AxiosRequestConfig | void): Promise<OK_API_AGENT_PLAYQUOTACOMUSER_MY_LIST.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/playQuotaComUser/my-list`, null, this || undefined)
}

/**
 * 新增子账号
 * @see https://api-doc.cxsport.net/#/view/E8rdomz0
 */
export const reqApiAgentBettingstationsubAdd = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_BETTING_STATION_SUB_ADD.REQ): Promise<OK_API_AGENT_BETTING_STATION_SUB_ADD.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/betting-station-sub/add`, params, this || undefined)
}

/**
 * 取得启用中所有国家
 * @see https://api-doc.cxsport.net/#/view/VzNRovzY
 */
export const reqApiAgentNationList = async function (this: AxiosRequestConfig | void): Promise<OK_API_AGENT_NATION_LIST.RES> {
  return (this?.instance || AgentAPI).get(`/api/agent/nation/list`, this || undefined)
}

/**
 * <p>查询资金明细</p>
 * @see https://api-doc.cxsport.net/#/view/wXnkxgz9
 */
export const reqApiAgentFinanceRecordBillList = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_FINANCERECORD_BILLLIST.REQ): Promise<OK_API_AGENT_FINANCERECORD_BILLLIST.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/financeRecord/billList`, params, this || undefined)
}

/**
 * 查询
 * @see https://api-doc.cxsport.net/#/view/W2oARRXD
 */
export const reqApiAgentAgentRoleQuery = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_AGENTROLE_QUERY.REQ): Promise<OK_API_AGENT_AGENTROLE_QUERY.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/agentRole/query`, params, this || undefined)
}

/**
 * 查询代理额度记录
 * @see https://api-doc.cxsport.net/#/view/aXYw7E2r
 */
export const reqApiAgentCreditRecordList = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_CREDITRECORD_LIST.REQ): Promise<OK_API_AGENT_CREDITRECORD_LIST.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/creditRecord/list`, params, this || undefined)
}

/**
 * 根据条件获取所有玩法组合
 * @see https://api-doc.cxsport.net/#/view/kXOgm5XD
 */
export const reqApiAgentPlayComUserMylist = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_PLAYCOMUSER_MY_LIST.REQ): Promise<OK_API_AGENT_PLAYCOMUSER_MY_LIST.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/playComUser/my-list`, params, this || undefined)
}

/**
 *
 * @see https://api-doc.cxsport.net/#/view/L2yPDZzm
 */
export const reqApiAgentBetList = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_BET_LIST.REQ): Promise<OK_API_AGENT_BET_LIST.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/bet/list`, params, this || undefined)
}

/**
 * 获取体育赛事分类
 * @see https://api-doc.cxsport.net/#/view/58ppAa83
 */
export const reqApiAgentSportList = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_SPORT_LIST.REQ): Promise<OK_API_AGENT_SPORT_LIST.RES> {
  return (this?.instance || AgentAPI).get(`/api/agent/sport/list`, { ...this, params })
}

/**
 * <p>投注站为用户提款</p>
 * @see https://api-doc.cxsport.net/#/view/42GA9yXW
 */
export const reqApiAgentUserwithdrawStationWithdraw = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_USER_WITHDRAW_STATIONWITHDRAW.REQ,
): Promise<OK_API_AGENT_USER_WITHDRAW_STATIONWITHDRAW.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/user-withdraw/stationWithdraw`, params, this || undefined)
}

/**
 *
 * @see https://api-doc.cxsport.net/#/view/d8x9ebXg
 */
export const reqApiAgentThirdOrderQueryThirdOrder = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_THIRDORDER_QUERYTHIRDORDER.REQ,
): Promise<OK_API_AGENT_THIRDORDER_QUERYTHIRDORDER.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/thirdOrder/queryThirdOrder`, params, this || undefined)
}

/**
 * 第三方游戏信息 游戏分类code
 * @see https://api-doc.cxsport.net/#/view/nzDRjZ8p
 */
export const reqApiAgentThirdapiThirdgamesCode = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_THIRDAPI_THIRDGAMES_CODE.REQ,
): Promise<OK_API_AGENT_THIRDAPI_THIRDGAMES_CODE.RES> {
  const { code } = params || {}
  return (this?.instance || AgentAPI).get(`/api/agent/thirdapi/thirdgames/${code}`, { ...this, params })
}

/**
 *
 * @see https://api-doc.cxsport.net/#/view/NzvBvBzD
 */
export const reqApiAgentChargeCfgQueryparamcfgbyparamParam = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_CHARGE_CFG_QUERYPARAMCFGBYPARAM_PARAM.REQ,
): Promise<OK_API_AGENT_CHARGE_CFG_QUERYPARAMCFGBYPARAM_PARAM.RES> {
  const { param } = params || {}
  return (this?.instance || AgentAPI).get(`/api/agent/charge/cfg/queryparamcfgbyparam/${param}`, { ...this, params })
}

/**
 * 全部列表
 * @see https://api-doc.cxsport.net/#/view/BXgvAK8G
 */
export const reqApiAgentGamecategoryList = async function (this: AxiosRequestConfig | void): Promise<OK_API_AGENT_GAME_CATEGORY_LIST.RES> {
  return (this?.instance || AgentAPI).get(`/api/agent/game-category/list`, this || undefined)
}

/**
 * 取得该会员的水位资料
 * @see https://api-doc.cxsport.net/#/view/aXYO4R2r
 */
export const reqApiAgentUserExtendUserMarginUserId = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_USEREXTEND_USERMARGIN_USERID.REQ,
): Promise<OK_API_AGENT_USEREXTEND_USERMARGIN_USERID.RES> {
  const { userId } = params || {}
  return (this?.instance || AgentAPI).get(`/api/agent/userExtend/userMargin/${userId}`, { ...this, params })
}

/**
 * 邀请码列表
 * @see https://api-doc.cxsport.net/#/view/a85K4WzZ
 */
export const reqApiAgentUserInviteList = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_USER_INVITE_LIST.REQ): Promise<OK_API_AGENT_USER_INVITE_LIST.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/user/invite/list`, params, this || undefined)
}

/**
 *
 * @see https://api-doc.cxsport.net/#/view/mzWP092l
 */
export const reqApiAgentUserrechStationRechList = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_USER_RECH_STATIONRECHLIST.REQ,
): Promise<OK_API_AGENT_USER_RECH_STATIONRECHLIST.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/user-rech/stationRechList`, params, this || undefined)
}

/**
 * 三方游戏佣金列表
 * @see https://api-doc.cxsport.net/#/view/32Q47Lz0
 */
export const reqApiAgentThirdcostList = async function (this: AxiosRequestConfig | void): Promise<OK_API_AGENT_THIRD_COST_LIST.RES> {
  return (this?.instance || AgentAPI).get(`/api/agent/third-cost/list`, this || undefined)
}

/**
 *
 * @see https://api-doc.cxsport.net/#/view/pX9WB92r
 */
export const reqApiAgentSettleQuerylist = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_SETTLE_QUERYLIST.REQ): Promise<OK_API_AGENT_SETTLE_QUERYLIST.RES> {
  return (this?.instance || AgentAPI).get(`/api/agent/settle/querylist`, { ...this, params })
}

/**
 *
 * @see https://api-doc.cxsport.net/#/view/42GAmyXW
 */
export const reqApiAgentUserRebateSave = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_USER_REBATE_SAVE.REQ): Promise<OK_API_AGENT_USER_REBATE_SAVE.RES> {
  return (this?.instance || AgentAPI).get(`/api/agent/user/rebate/save`, { ...this, params })
}

/**
 *
 * @see https://api-doc.cxsport.net/#/view/JzAVbY2p
 */
export const reqApiAgentDirectLowerAgentList = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_DIRECTLOWERAGENT_LIST.REQ): Promise<OK_API_AGENT_DIRECTLOWERAGENT_LIST.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/directLowerAgent/list`, params, this || undefined)
}

/**
 * 取得该平台的水位设置值
 * @see https://api-doc.cxsport.net/#/view/Wz350n8R
 */
export const reqApiAgentPlatformCreditMarginLevelList = async function (this: AxiosRequestConfig | void): Promise<OK_API_AGENT_PLATFORMCREDITMARGINLEVEL_LIST.RES> {
  return (this?.instance || AgentAPI).get(`/api/agent/platformCreditMarginLevel/list`, this || undefined)
}

/**
 * <p>数据概览</p>
 * @see https://api-doc.cxsport.net/#/view/N2elbvze
 */
export const reqApiAgentPlatformStationStatisticSummaryReport = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_PLATFORM_STATION_STATISTIC_SUMMARYREPORT.REQ,
): Promise<OK_API_AGENT_PLATFORM_STATION_STATISTIC_SUMMARYREPORT.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/platform/station/statistic/summaryReport`, params, this || undefined)
}

/**
 * <p>获得验证码</p>
 * @see https://api-doc.cxsport.net/#/view/W2o0ke8D
 */
export const reqApiAgentIndexGetvalidatecode = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_INDEX_GETVALIDATECODE.REQ): Promise<OK_API_AGENT_INDEX_GETVALIDATECODE.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/index/getvalidatecode`, params, this || undefined)
}

/**
 *
 * @see https://api-doc.cxsport.net/#/view/kXO0mdzD
 */
export const reqApiAgentGameConfigGetConfigByNameName = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_GAME_CONFIG_GETCONFIGBYNAME_NAME.REQ,
): Promise<OK_API_AGENT_GAME_CONFIG_GETCONFIGBYNAME_NAME.RES> {
  const { name } = params || {}
  return (this?.instance || AgentAPI).get(`/api/agent/game/config/getConfigByName/${name}`, { ...this, params })
}

/**
 * 发送验证码
 * @see https://api-doc.cxsport.net/#/view/58pdAL83
 */
export const reqApiAgentSmsSendSms = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_SMS_SENDSMS.REQ): Promise<OK_API_AGENT_SMS_SENDSMS.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/sms/sendSms`, params, this || undefined)
}

/**
 * 获取真金会员的钱包余额
 * @see https://api-doc.cxsport.net/#/view/32Q4nLz0
 */
export const reqApiAgentRealGoldMemberQueryRealGoldMemberMoney = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_REALGOLDMEMBER_QUERYREALGOLDMEMBERMONEY.REQ,
): Promise<OK_API_AGENT_REALGOLDMEMBER_QUERYREALGOLDMEMBERMONEY.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/realGoldMember/queryRealGoldMemberMoney`, params, this || undefined)
}

/**
 * 获取时间轴
 * @see https://api-doc.cxsport.net/#/view/wXPderXn
 */
export const reqApiAgentTimeline = async function (this: AxiosRequestConfig | void): Promise<OK_API_AGENT_TIMELINE.RES> {
  return (this?.instance || AgentAPI).get(`/api/agent/timeline`, this || undefined)
}

/**
 * 提款列表
 * @see https://api-doc.cxsport.net/#/view/P814od2q
 */
export const reqApiAgentAgentwithdrawList = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_AGENTWITHDRAW_LIST.REQ): Promise<OK_API_AGENT_AGENTWITHDRAW_LIST.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/agentwithdraw/list`, params, this || undefined)
}

/**
 * 我的占成配置
 * @see https://api-doc.cxsport.net/#/view/nzdajD2j
 */
export const reqApiAgentThirdcustomconfigMyconfig = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_THIRD_CUSTOM_CONFIG_MY_CONFIG.REQ,
): Promise<OK_API_AGENT_THIRD_CUSTOM_CONFIG_MY_CONFIG.RES> {
  return (this?.instance || AgentAPI).get(`/api/agent/third-custom-config/my-config`, { ...this, params })
}

/**
 *
 * @see https://api-doc.cxsport.net/#/view/qXBR9WXE
 */
export const reqApiAgentGamefirmQueryFirmCodes = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_GAMEFIRM_QUERYFIRMCODES.REQ,
): Promise<OK_API_AGENT_GAMEFIRM_QUERYFIRMCODES.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/gamefirm/queryFirmCodes`, params, this || undefined)
}

/**
 *
 * @see https://api-doc.cxsport.net/#/view/wXPdeeXn
 */
export const reqApiAgentPlatformUserStatisticVipreport = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_PLATFORM_USER_STATISTIC_VIPREPORT.REQ,
): Promise<OK_API_AGENT_PLATFORM_USER_STATISTIC_VIPREPORT.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/platform/user/statistic/vipreport`, params, this || undefined)
}

/**
 * 投注站详情
 * @see https://api-doc.cxsport.net/#/view/Wz35Nj8R
 */
export const reqApiAgentBettingstationMystationdetail = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_BETTING_STATION_MY_STATION_DETAIL.REQ,
): Promise<OK_API_AGENT_BETTING_STATION_MY_STATION_DETAIL.RES> {
  return (this?.instance || AgentAPI).get(`/api/agent/betting-station/my-station-detail`, { ...this, params })
}

/**
 * 直属会员列表
 * @see https://api-doc.cxsport.net/#/view/nzDRVG8p
 */
export const reqApiAgentUserQueryDirectList = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_USER_QUERYDIRECTLIST.REQ): Promise<OK_API_AGENT_USER_QUERYDIRECTLIST.RES> {
  return (this?.instance || AgentAPI).get(`/api/agent/user/queryDirectList`, { ...this, params })
}

/**
 * 检查用户是否有拥有某个权限 历史页面太多，很多代理页面公用一个后台请求，如果在controller上直接配MenuCodes有可能误伤 所以碰到哪个页面的具体请求就手动验证下
 * @see https://api-doc.cxsport.net/#/view/VXEypAXv
 */
export const reqApiAgentPermissionCheck = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_PERMISSION_CHECK.REQ): Promise<any> {
  return (this?.instance || AgentAPI).get(`/api/agent/permission/check`, { ...this, params })
}

/**
 *
 * @see https://api-doc.cxsport.net/#/view/BXgRyLx8
 */
export const reqApiAgentSingleWalletTaskQuery = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_SINGLEWALLET_TASK_QUERY.REQ): Promise<OK_API_AGENT_SINGLEWALLET_TASK_QUERY.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/singleWallet/task/query`, params, this || undefined)
}

/**
 * 查询佣金配置列表
 * @see https://api-doc.cxsport.net/#/view/r2jZywb2
 */
export const reqApiAgentAgentEarningsConfigQuery = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_AGENTEARNINGSCONFIG_QUERY.REQ,
): Promise<OK_API_AGENT_AGENTEARNINGSCONFIG_QUERY.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/agentEarningsConfig/query`, params, this || undefined)
}

/**
 * 查询佣金配置列表
 * @see https://api-doc.cxsport.net/#/view/a26oGxV8
 */
export const reqApiAgentBetStationCommissionConfigQueryCfgList = async function (this: AxiosRequestConfig | void): Promise<OK_API_AGENT_BETSTATIONCOMMISSIONCONFIG_QUERYCFGLIST.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/betStationCommissionConfig/queryCfgList`, null, this || undefined)
}

/**
 * 查询佣金报表列表
 * @see https://api-doc.cxsport.net/#/view/V2JRvd72
 */
export const reqApiAgentBetStationCommissionReportQueryReportPage = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_BETSTATIONCOMMISSIONREPORT_QUERYREPORTPAGE.REQ,
): Promise<OK_API_AGENT_BETSTATIONCOMMISSIONREPORT_QUERYREPORTPAGE.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/betStationCommissionReport/queryReportPage`, params, this || undefined)
}

/**
 * 获取所有工作性质列表
 * @see https://api-doc.cxsport.net/#/view/nzdWyVBX
 */
export const reqApiAgentWorksQueryAll = async function (this: AxiosRequestConfig | void): Promise<OK_API_AGENT_WORKS_QUERYALL.RES> {
  return (this?.instance || AgentAPI).get(`/api/agent/works/queryAll`, this || undefined)
}

/**
 * 现金额度报表 查询
 * @see https://api-doc.cxsport.net/#/view/58ppybo8
 */
export const reqApiAgentStationQuotaChangeLogQuery = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_STATIONQUOTACHANGELOG_QUERY.REQ,
): Promise<OK_API_AGENT_STATIONQUOTACHANGELOG_QUERY.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/stationQuotaChangeLog/query`, params, this || undefined)
}

/**
 * 现金额度报表 查询
 * @see https://api-doc.cxsport.net/#/view/nzdWy4qX
 */
export const reqApiAgentAgentCommissionChangeLogQuery = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_AGENTCOMMISSIONCHANGELOG_QUERY.REQ,
): Promise<OK_API_AGENT_AGENTCOMMISSIONCHANGELOG_QUERY.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/agentCommissionChangeLog/query`, params, this || undefined)
}

/**
 * 转账
 * @see https://api-doc.cxsport.net/#/view/e24oL4xz
 */
export const reqApiAgentAgentCommissionTransfer = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_AGENTCOMMISSION_TRANSFER.REQ,
): Promise<OK_API_AGENT_AGENTCOMMISSION_TRANSFER.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/agentCommission/transfer`, params, this || undefined)
}

/**
 * 个人资料
 * @see https://api-doc.cxsport.net/#/view/32QMy9G2
 */
export const reqApiAgentCenterInfo = async function (this: AxiosRequestConfig | void): Promise<OK_API_AGENT_CENTER_INFO.RES> {
  return (this?.instance || AgentAPI).get(`/api/agent/center/info`, this || undefined)
}

/**
 * 根据userName查找会员信息，获取实名认证配置信息
 * @see https://api-doc.cxsport.net/#/view/Wz3jPLgX
 */
export const reqApiAgentUserKycGetByUserNameUserName = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_USERKYC_GETBYUSERNAME_USERNAME.REQ,
): Promise<OK_API_AGENT_USERKYC_GETBYUSERNAME_USERNAME.RES> {
  const { userName } = params || {}
  return (this?.instance || AgentAPI).get(`/api/agent/userKyc/getByUserName/${userName}`, { ...this, params })
}

/**
 * 地区树
 * @see https://api-doc.cxsport.net/#/view/nzDODdaX
 */
export const reqApiAgentAreaTree = async function (this: AxiosRequestConfig | void): Promise<OK_API_AGENT_AREA_TREE.RES> {
  return (this?.instance || AgentAPI).get(`/api/agent/area/tree`, this || undefined)
}

/**
 * 查询佣金报表列表
 * @see https://api-doc.cxsport.net/#/view/7zLO1bVX
 */
export const reqApiAgentAgentCommissionBetReportQueryReportPage = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_AGENTCOMMISSIONBETREPORT_QUERYREPORTPAGE.REQ,
): Promise<OK_API_AGENT_AGENTCOMMISSIONBETREPORT_QUERYREPORTPAGE.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/agentCommissionBetReport/queryReportPage`, params, this || undefined)
}

/**
 * 查看详情
 * @see https://api-doc.cxsport.net/#/view/e24oM0xz
 */
export const reqApiAgentAgentEarningsBetConfigGet = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_AGENTEARNINGSBETCONFIG_GET.REQ,
): Promise<OK_API_AGENT_AGENTEARNINGSBETCONFIG_GET.RES> {
  return (this?.instance || AgentAPI).get(`/api/agent/agentEarningsBetConfig/get`, { ...this, params })
}

/**
 * 查询佣金报表列表
 * @see https://api-doc.cxsport.net/#/view/r2jAYd1z
 */
export const reqApiAgentAgentCommissionProfitReportQueryReportPage = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_AGENTCOMMISSIONPROFITREPORT_QUERYREPORTPAGE.REQ,
): Promise<OK_API_AGENT_AGENTCOMMISSIONPROFITREPORT_QUERYREPORTPAGE.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/agentCommissionProfitReport/queryReportPage`, params, this || undefined)
}

/**
 * 查看详情
 * @see https://api-doc.cxsport.net/#/view/nzdaEAb2
 */
export const reqApiAgentAgentEarningsProfitConfigGet = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_AGENTEARNINGSPROFITCONFIG_GET.REQ,
): Promise<OK_API_AGENT_AGENTEARNINGSPROFITCONFIG_GET.RES> {
  return (this?.instance || AgentAPI).get(`/api/agent/agentEarningsProfitConfig/get`, { ...this, params })
}

/**
 * 外部投注站兌換紀錄查詢
 * @see https://api-doc.cxsport.net/#/view/qXbm95O8
 */
export const reqApiAgentExternalTransferQueryTransferExtStation = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_EXTERNAL_TRANSFER_QUERYTRANSFER_EXTSTATION.REQ,
): Promise<OK_API_AGENT_EXTERNAL_TRANSFER_QUERYTRANSFER_EXTSTATION.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/external/transfer/queryTransfer/extStation`, params, this || undefined)
}

/**
 * 取得所有币别
 * @see https://api-doc.cxsport.net/#/view/32QM7R20
 */
export const reqApiAgentCurrencyListAll = async function (this: AxiosRequestConfig | void): Promise<OK_API_AGENT_CURRENCY_LISTALL.RES> {
  return (this?.instance || AgentAPI).get(`/api/agent/currency/listAll`, this || undefined)
}

/**
 * 根据条件获取所有交易组合
 * @see https://api-doc.cxsport.net/#/view/P81Klezq
 */
export const reqApiAgentPlayQuotaComUserListUserId = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_PLAYQUOTACOMUSER_LIST_USERID.REQ,
): Promise<OK_API_AGENT_PLAYQUOTACOMUSER_LIST_USERID.RES> {
  const { userId } = params || {}
  return (this?.instance || AgentAPI).post(`/api/agent/playQuotaComUser/list/${userId}`, params, this || undefined)
}

/**
 * 修改子账号
 * @see https://api-doc.cxsport.net/#/view/qXb7GVzv
 */
export const reqApiAgentBettingstationsubUpdate = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_BETTING_STATION_SUB_UPDATE.REQ,
): Promise<OK_API_AGENT_BETTING_STATION_SUB_UPDATE.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/betting-station-sub/update`, params, this || undefined)
}

/**
 * 取得所有国家
 * @see https://api-doc.cxsport.net/#/view/Pzmen3zJ
 */
export const reqApiAgentNationListAll = async function (this: AxiosRequestConfig | void): Promise<OK_API_AGENT_NATION_LISTALL.RES> {
  return (this?.instance || AgentAPI).get(`/api/agent/nation/listAll`, this || undefined)
}

/**
 * <p>导出资金明细</p>
 * @see https://api-doc.cxsport.net/#/view/d8xVg6zg
 */
export const reqApiAgentFinanceRecordBillListExport = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_FINANCERECORD_BILLLISTEXPORT.REQ,
): Promise<OK_API_AGENT_FINANCERECORD_BILLLISTEXPORT.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/financeRecord/billListExport`, params, this || undefined)
}

/**
 * 查看详情
 * @see https://api-doc.cxsport.net/#/view/K2ZwEv8v
 */
export const reqApiAgentAgentRoleGetId = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_AGENTROLE_GET_ID.REQ): Promise<OK_API_AGENT_AGENTROLE_GET_ID.RES> {
  const { id } = params || {}
  return (this?.instance || AgentAPI).get(`/api/agent/agentRole/get/${id}`, { ...this, params })
}

/**
 * 根据条件获取所有玩法组合
 * @see https://api-doc.cxsport.net/#/view/a85ava8Z
 */
export const reqApiAgentPlayComUserListUserId = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_PLAYCOMUSER_LIST_USERID.REQ): Promise<OK_API_AGENT_PLAYCOMUSER_LIST_USERID.RES> {
  const { userId } = params || {}
  return (this?.instance || AgentAPI).post(`/api/agent/playComUser/list/${userId}`, params, this || undefined)
}

/**
 * <p>提现列表</p>
 * @see https://api-doc.cxsport.net/#/view/m8wBmp2k
 */
export const reqApiAgentUserwithdrawStationWithdrawList = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_USER_WITHDRAW_STATIONWITHDRAWLIST.REQ,
): Promise<OK_API_AGENT_USER_WITHDRAW_STATIONWITHDRAWLIST.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/user-withdraw/stationWithdrawList`, params, this || undefined)
}

/**
 * 取得上级水位资料
 * @see https://api-doc.cxsport.net/#/view/Q2VLWkXe
 */
export const reqApiAgentUserExtendSuperMarginUserId = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_USEREXTEND_SUPERMARGIN_USERID.REQ,
): Promise<OK_API_AGENT_USEREXTEND_SUPERMARGIN_USERID.RES> {
  const { userId } = params || {}
  return (this?.instance || AgentAPI).get(`/api/agent/userExtend/superMargin/${userId}`, { ...this, params })
}

/**
 * 生成邀请码
 * @see https://api-doc.cxsport.net/#/view/xXaj1Rzo
 */
export const reqApiAgentUserInviteSave = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_USER_INVITE_SAVE.REQ): Promise<OK_API_AGENT_USER_INVITE_SAVE.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/user/invite/save`, params, this || undefined)
}

/**
 *
 * @see https://api-doc.cxsport.net/#/view/58pdDL83
 */
export const reqApiAgentUserrechStationRechListExport = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_USER_RECH_STATIONRECHLISTEXPORT.REQ,
): Promise<OK_API_AGENT_USER_RECH_STATIONRECHLISTEXPORT.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/user-rech/stationRechListExport`, params, this || undefined)
}

/**
 *
 * @see https://api-doc.cxsport.net/#/view/wXPdKrXn
 */
export const reqApiAgentSettleQueryunsettled = async function (this: AxiosRequestConfig | void): Promise<OK_API_AGENT_SETTLE_QUERYUNSETTLED.RES> {
  return (this?.instance || AgentAPI).get(`/api/agent/settle/queryunsettled`, this || undefined)
}

/**
 *
 * @see https://api-doc.cxsport.net/#/view/m8wB6p2k
 */
export const reqApiAgentUserRebateListUserId = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_USER_REBATE_LIST_USERID.REQ): Promise<OK_API_AGENT_USER_REBATE_LIST_USERID.RES> {
  const { userId } = params || {}
  return (this?.instance || AgentAPI).get(`/api/agent/user/rebate/list/${userId}`, { ...this, params })
}

/**
 * 保存用户水位盘口等级
 * @see https://api-doc.cxsport.net/#/view/VzNpoo8Y
 */
export const reqApiAgentPlatformCreditMarginLevelSaveUserMarginLevel = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_PLATFORMCREDITMARGINLEVEL_SAVEUSERMARGINLEVEL.REQ,
): Promise<OK_API_AGENT_PLATFORMCREDITMARGINLEVEL_SAVEUSERMARGINLEVEL.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/platformCreditMarginLevel/saveUserMarginLevel`, params, this || undefined)
}

/**
 * <p>按天获取ggr信息</p>
 * @see https://api-doc.cxsport.net/#/view/wXnpxy29
 */
export const reqApiAgentPlatformStationStatisticGgrDaily = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_PLATFORM_STATION_STATISTIC_GGRDAILY.REQ,
): Promise<OK_API_AGENT_PLATFORM_STATION_STATISTIC_GGRDAILY.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/platform/station/statistic/ggrDaily`, params, this || undefined)
}

/**
 * 登录
 * @see https://api-doc.cxsport.net/#/view/K2ZOvn8v
 */
export const reqApiAgentIndexLogin = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_INDEX_LOGIN.REQ): Promise<OK_API_AGENT_INDEX_LOGIN.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/index/login`, params, this || undefined)
}

/**
 * 验证短信验证码
 * @see https://api-doc.cxsport.net/#/view/YX0dMWXx
 */
export const reqApiAgentSmsVerifySms = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_SMS_VERIFYSMS.REQ): Promise<OK_API_AGENT_SMS_VERIFYSMS.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/sms/verifySms`, params, this || undefined)
}

/**
 * 真金会员实时下分
 * @see https://api-doc.cxsport.net/#/view/qXBR95XE
 */
export const reqApiAgentRealGoldMemberSubtract = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_REALGOLDMEMBER_SUBTRACT.REQ,
): Promise<OK_API_AGENT_REALGOLDMEMBER_SUBTRACT.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/realGoldMember/subtract`, params, this || undefined)
}

/**
 * 根据游戏分类查询用户自定义占成列表
 * @see https://api-doc.cxsport.net/#/view/e24Z70XL
 */
export const reqApiAgentThirdcustomconfigUserIdGameCategoryId = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_THIRD_CUSTOM_CONFIG_USERID_GAMECATEGORYID.REQ,
): Promise<OK_API_AGENT_THIRD_CUSTOM_CONFIG_USERID_GAMECATEGORYID.RES> {
  const { userId, gameCategoryId } = params || {}
  return (this?.instance || AgentAPI).get(`/api/agent/third-custom-config/${userId}/${gameCategoryId}`, { ...this, params })
}

/**
 *
 * @see https://api-doc.cxsport.net/#/view/7zLNqB8Q
 */
export const reqApiAgentPlatformUserStatisticExportvipreport = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_PLATFORM_USER_STATISTIC_EXPORTVIPREPORT.REQ,
): Promise<OK_API_AGENT_PLATFORM_USER_STATISTIC_EXPORTVIPREPORT.RES> {
  return (this?.instance || AgentAPI).get(`/api/agent/platform/user/statistic/exportvipreport`, { ...this, params })
}

/**
 * 根据userName查找会员信息，只有投注站才有权限查找
 * @see https://api-doc.cxsport.net/#/view/VzNpPp8Y
 */
export const reqApiAgentBettingstationGetByUserNameUserName = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_BETTING_STATION_GETBYUSERNAME_USERNAME.REQ,
): Promise<OK_API_AGENT_BETTING_STATION_GETBYUSERNAME_USERNAME.RES> {
  const { userName } = params || {}
  return (this?.instance || AgentAPI).get(`/api/agent/betting-station/getByUserName/${userName}`, { ...this, params })
}

/**
 *
 * @see https://api-doc.cxsport.net/#/view/K8MN97Xl
 */
export const reqApiAgentUserQuerylist = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_USER_QUERYLIST.REQ): Promise<OK_API_AGENT_USER_QUERYLIST.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/user/querylist`, params, this || undefined)
}

/**
 *
 * @see https://api-doc.cxsport.net/#/view/B2lGybmz
 */
export const reqApiAgentSingleWalletTaskGetAllAction = async function (this: AxiosRequestConfig | void): Promise<OK_API_AGENT_SINGLEWALLET_TASK_GETALLACTION.RES> {
  return (this?.instance || AgentAPI).get(`/api/agent/singleWallet/task/getAllAction`, this || undefined)
}

/**
 * <p>投注站投注记录</p>
 * @see https://api-doc.cxsport.net/#/view/YX0wQmR8
 */
export const reqApiAgentBetBettingRecordlist = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_BET_BETTINGRECORDLIST.REQ): Promise<OK_API_AGENT_BET_BETTINGRECORDLIST.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/bet/bettingRecordlist`, params, this || undefined)
}

/**
 * 新增佣金方案
 * @see https://api-doc.cxsport.net/#/view/32QMyL52
 */
export const reqApiAgentAgentEarningsConfigAdd = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_AGENTEARNINGSCONFIG_ADD.REQ,
): Promise<OK_API_AGENT_AGENTEARNINGSCONFIG_ADD.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/agentEarningsConfig/add`, params, this || undefined)
}

/**
 *
 * @see https://api-doc.cxsport.net/#/view/W2oAyV0X
 */
export const reqApiAgentThirdOrderQueryBettingThirdOrder = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_THIRDORDER_QUERYBETTINGTHIRDORDER.REQ,
): Promise<OK_API_AGENT_THIRDORDER_QUERYBETTINGTHIRDORDER.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/thirdOrder/queryBettingThirdOrder`, params, this || undefined)
}

/**
 * 通过代理ID查询返回包含当前所在的配置租和佣金配置列表
 * @see https://api-doc.cxsport.net/#/view/BXgRyVx8
 */
export const reqApiAgentBetStationCommissionConfigQueryCfgListByAgentIdAgentId = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_BETSTATIONCOMMISSIONCONFIG_QUERYCFGLISTBYAGENTID_AGENTID.REQ,
): Promise<OK_API_AGENT_BETSTATIONCOMMISSIONCONFIG_QUERYCFGLISTBYAGENTID_AGENTID.RES> {
  const { agentId } = params || {}
  return (this?.instance || AgentAPI).get(`/api/agent/betStationCommissionConfig/queryCfgListByAgentId/${agentId}`, { ...this, params })
}

/**
 * 查询期数集合
 * @see https://api-doc.cxsport.net/#/view/L2yP04Ez
 */
export const reqApiAgentBetStationCommissionReportQueryDateCodeList = async function (this: AxiosRequestConfig | void): Promise<OK_API_AGENT_BETSTATIONCOMMISSIONREPORT_QUERYDATECODELIST.RES> {
  return (this?.instance || AgentAPI).get(`/api/agent/betStationCommissionReport/queryDateCodeList`, this || undefined)
}

/**
 *
 * @see https://api-doc.cxsport.net/#/view/VzNRYjxz
 */
export const reqApiAgentDirectLowerAgentDetailList = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_DIRECTLOWERAGENT_DETAILLIST.REQ,
): Promise<OK_API_AGENT_DIRECTLOWERAGENT_DETAILLIST.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/directLowerAgent/detailList`, params, this || undefined)
}

/**
 * 获取当前用户到所有下级
 * @see https://api-doc.cxsport.net/#/view/VXELMN38
 */
export const reqApiAgentAgentCommissionGetAubAgent = async function (this: AxiosRequestConfig | void): Promise<OK_API_AGENT_AGENTCOMMISSION_GETAUBAGENT.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/agentCommission/getAubAgent`, null, this || undefined)
}

/**
 * <p>获取验证码</p>
 * @see https://api-doc.cxsport.net/#/view/qXBZxAxX
 */
export const reqApiAgentCenterSendValidCode = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_CENTER_SENDVALIDCODE.REQ): Promise<OK_API_AGENT_CENTER_SENDVALIDCODE.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/center/sendValidCode`, params, this || undefined)
}

/**
 * <p>审核通过</p>
 * @see https://api-doc.cxsport.net/#/view/VzNRYGxz
 */
export const reqApiAgentUserKycPass = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_USERKYC_PASS.REQ): Promise<OK_API_AGENT_USERKYC_PASS.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/userKyc/pass`, params, this || undefined)
}

/**
 * 通用国家列表
 * @see https://api-doc.cxsport.net/#/view/K8Mgl1wz
 */
export const reqApiAgentAreaUniversal = async function (this: AxiosRequestConfig | void): Promise<OK_API_AGENT_AREA_UNIVERSAL.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/area/universal`, null, this || undefined)
}

/**
 *
 * @see https://api-doc.cxsport.net/#/view/bXKZ6Pl8
 */
export const reqApiAgentAgentwithdrawQuerystatistic = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_AGENTWITHDRAW_QUERYSTATISTIC.REQ,
): Promise<OK_API_AGENT_AGENTWITHDRAW_QUERYSTATISTIC.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/agentwithdraw/querystatistic`, params, this || undefined)
}

/**
 * 查询佣金报表明细
 * @see https://api-doc.cxsport.net/#/view/P81KxAGz
 */
export const reqApiAgentAgentCommissionBetReportQueryReportDetail = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_AGENTCOMMISSIONBETREPORT_QUERYREPORTDETAIL.REQ,
): Promise<OK_API_AGENT_AGENTCOMMISSIONBETREPORT_QUERYREPORTDETAIL.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/agentCommissionBetReport/queryReportDetail`, params, this || undefined)
}

/**
 * 查询佣金配置列表
 * @see https://api-doc.cxsport.net/#/view/VXELEq38
 */
export const reqApiAgentAgentEarningsBetConfigQuery = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_AGENTEARNINGSBETCONFIG_QUERY.REQ,
): Promise<OK_API_AGENT_AGENTEARNINGSBETCONFIG_QUERY.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/agentEarningsBetConfig/query`, params, this || undefined)
}

/**
 * 查询佣金报表明细
 * @see https://api-doc.cxsport.net/#/view/32Q4vBGz
 */
export const reqApiAgentAgentCommissionProfitReportQueryReportDetail = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_AGENTCOMMISSIONPROFITREPORT_QUERYREPORTDETAIL.REQ,
): Promise<OK_API_AGENT_AGENTCOMMISSIONPROFITREPORT_QUERYREPORTDETAIL.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/agentCommissionProfitReport/queryReportDetail`, params, this || undefined)
}

/**
 * 查询佣金配置列表
 * @see https://api-doc.cxsport.net/#/view/e24ZJYoX
 */
export const reqApiAgentAgentEarningsProfitConfigQuery = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_AGENTEARNINGSPROFITCONFIG_QUERY.REQ,
): Promise<OK_API_AGENT_AGENTEARNINGSPROFITCONFIG_QUERY.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/agentEarningsProfitConfig/query`, params, this || undefined)
}

/**
 * 取得所有投注站
 * @see https://api-doc.cxsport.net/#/view/B2lnqw0X
 */
export const reqApiAgentExternalTransferGetAllStation = async function (this: AxiosRequestConfig | void): Promise<OK_API_AGENT_EXTERNAL_TRANSFER_GETALLSTATION.RES> {
  return (this?.instance || AgentAPI).get(`/api/agent/external/transfer/getAllStation`, this || undefined)
}

/**
 * 取得系统币别
 * @see https://api-doc.cxsport.net/#/view/qXBZkdXE
 */
export const reqApiAgentCurrencyGetSysCurrency = async function (this: AxiosRequestConfig | void): Promise<OK_API_AGENT_CURRENCY_GETSYSCURRENCY.RES> {
  return (this?.instance || AgentAPI).get(`/api/agent/currency/getSysCurrency`, this || undefined)
}

/**
 * 保存or更新用户返水
 * @see https://api-doc.cxsport.net/#/view/42G5m1XW
 */
export const reqApiAgentPlayQuotaComUserSaveOrUpdate = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_PLAYQUOTACOMUSER_SAVEORUPDATE.REQ,
): Promise<OK_API_AGENT_PLAYQUOTACOMUSER_SAVEORUPDATE.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/playQuotaComUser/saveOrUpdate`, params, this || undefined)
}

/**
 * 查询
 * @see https://api-doc.cxsport.net/#/view/L2kJmLzP
 */
export const reqApiAgentBettingstationsubQuery = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_BETTING_STATION_SUB_QUERY.REQ,
): Promise<OK_API_AGENT_BETTING_STATION_SUB_QUERY.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/betting-station-sub/query`, params, this || undefined)
}

/**
 * 投注站交易类型
 * @see https://api-doc.cxsport.net/#/view/q2REvYzg
 */
export const reqApiAgentFinanceRecordStationTranTypes = async function (this: AxiosRequestConfig | void): Promise<OK_API_AGENT_FINANCERECORD_STATIONTRANTYPES.RES> {
  return (this?.instance || AgentAPI).get(`/api/agent/financeRecord/stationTranTypes`, this || undefined)
}

/**
 * 获取权限菜单
 * @see https://api-doc.cxsport.net/#/view/bXKZRQ87
 */
export const reqApiAgentAgentRoleMenu = async function (this: AxiosRequestConfig | void): Promise<OK_API_AGENT_AGENTROLE_MENU.RES> {
  return (this?.instance || AgentAPI).get(`/api/agent/agentRole/menu`, this || undefined)
}

/**
 * 保存or更新用户返水
 * @see https://api-doc.cxsport.net/#/view/xXaZdjzo
 */
export const reqApiAgentPlayComUserSaveOrUpdate = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_PLAYCOMUSER_SAVEORUPDATE.REQ,
): Promise<OK_API_AGENT_PLAYCOMUSER_SAVEORUPDATE.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/playComUser/saveOrUpdate`, params, this || undefined)
}

/**
 * <p>导出</p>
 * @see https://api-doc.cxsport.net/#/view/E8rqkL20
 */
export const reqApiAgentUserwithdrawStationWithdrawListExport = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_USER_WITHDRAW_STATIONWITHDRAWLISTEXPORT.REQ,
): Promise<OK_API_AGENT_USER_WITHDRAW_STATIONWITHDRAWLISTEXPORT.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/user-withdraw/stationWithdrawListExport`, params, this || undefined)
}

/**
 * 删除邀请码
 * @see https://api-doc.cxsport.net/#/view/V2Jbxm2y
 */
export const reqApiAgentUserInviteDeleteId = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_USER_INVITE_DELETE_ID.REQ): Promise<OK_API_AGENT_USER_INVITE_DELETE_ID.RES> {
  const { id } = params || {}
  return (this?.instance || AgentAPI).post(`/api/agent/user/invite/delete/${id}`, params, this || undefined)
}

/**
 * <p>投注站为用户充值</p>
 * @see https://api-doc.cxsport.net/#/view/YX0dgWXx
 */
export const reqApiAgentUserrechStationRech = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_USER_RECH_STATIONRECH.REQ): Promise<OK_API_AGENT_USER_RECH_STATIONRECH.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/user-rech/stationRech`, params, this || undefined)
}

/**
 *
 * @see https://api-doc.cxsport.net/#/view/7zLNDm8Q
 */
export const reqApiAgentSettleApply = async function (this: AxiosRequestConfig | void): Promise<OK_API_AGENT_SETTLE_APPLY.RES> {
  return (this?.instance || AgentAPI).get(`/api/agent/settle/apply`, this || undefined)
}

/**
 *
 * @see https://api-doc.cxsport.net/#/view/E8rqoL20
 */
export const reqApiAgentUserRebateSaveThird = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_USER_REBATE_SAVETHIRD.REQ): Promise<OK_API_AGENT_USER_REBATE_SAVETHIRD.RES> {
  return (this?.instance || AgentAPI).get(`/api/agent/user/rebate/saveThird`, { ...this, params })
}

/**
 * <p>按月获取ggr信息,默认1年</p>
 * @see https://api-doc.cxsport.net/#/view/d8x9gbXg
 */
export const reqApiAgentPlatformStationStatisticGgrMonth = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_PLATFORM_STATION_STATISTIC_GGRMONTH.REQ,
): Promise<OK_API_AGENT_PLATFORM_STATION_STATISTIC_GGRMONTH.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/platform/station/statistic/ggrMonth`, params, this || undefined)
}

/**
 * 是否启用验证码
 * @see https://api-doc.cxsport.net/#/view/bXKkAWX7
 */
export const reqApiAgentIndexV1Validcodeenable = async function (this: AxiosRequestConfig | void): Promise<OK_API_AGENT_INDEX_V1_VALIDCODEENABLE.RES> {
  return (this?.instance || AgentAPI).get(`/api/agent/index/v1/validcodeenable`, this || undefined)
}

/**
 * 添加提款信息
 * @see https://api-doc.cxsport.net/#/view/58pdAE83
 */
export const reqApiAgentAgentwithdrawAdd = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_AGENTWITHDRAW_ADD.REQ): Promise<OK_API_AGENT_AGENTWITHDRAW_ADD.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/agentwithdraw/add`, params, this || undefined)
}

/**
 * 保存自定义占成
 * @see https://api-doc.cxsport.net/#/view/VXEy1AXv
 */
export const reqApiAgentThirdcustomconfigSave = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_THIRD_CUSTOM_CONFIG_SAVE.REQ,
): Promise<OK_API_AGENT_THIRD_CUSTOM_CONFIG_SAVE.RES> {
  return (this?.instance || AgentAPI).get(`/api/agent/third-custom-config/save`, { ...this, params })
}

/**
 * 会员报表
 * @see https://api-doc.cxsport.net/#/view/P814oB2q
 */
export const reqApiAgentPlatformUserStatisticQueryOrdersByUser = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_PLATFORM_USER_STATISTIC_QUERYORDERSBYUSER.REQ,
): Promise<OK_API_AGENT_PLATFORM_USER_STATISTIC_QUERYORDERSBYUSER.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/platform/user/statistic/queryOrdersByUser`, params, this || undefined)
}

/**
 * 投注站，代理 金额信息；
 * @see https://api-doc.cxsport.net/#/view/PzmAdbzJ
 */
export const reqApiAgentBettingstationGetMoneyInfo = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_BETTING_STATION_GETMONEYINFO.REQ,
): Promise<OK_API_AGENT_BETTING_STATION_GETMONEYINFO.RES> {
  return (this?.instance || AgentAPI).get(`/api/agent/betting-station/getMoneyInfo`, { ...this, params })
}

/**
 *
 * @see https://api-doc.cxsport.net/#/view/W2o0E98D
 */
export const reqApiAgentUserSaveCreditAgent = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_USER_SAVECREDITAGENT.REQ): Promise<OK_API_AGENT_USER_SAVECREDITAGENT.RES> {
  return (this?.instance || AgentAPI).get(`/api/agent/user/saveCreditAgent`, { ...this, params })
}

/**
 * 重新请求处理失败的单钱包任务
 * @see https://api-doc.cxsport.net/#/view/aXYwyqJ2
 */
export const reqApiAgentSingleWalletTaskReprocessFailedTask = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_SINGLEWALLET_TASK_REPROCESSFAILEDTASK.REQ,
): Promise<OK_API_AGENT_SINGLEWALLET_TASK_REPROCESSFAILEDTASK.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/singleWallet/task/reprocessFailedTask`, params, this || undefined)
}

/**
 * 修改佣金方案
 * @see https://api-doc.cxsport.net/#/view/qXBZxn3X
 */
export const reqApiAgentAgentEarningsConfigUpdate = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_AGENTEARNINGSCONFIG_UPDATE.REQ,
): Promise<OK_API_AGENT_AGENTEARNINGSCONFIG_UPDATE.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/agentEarningsConfig/update`, params, this || undefined)
}

/**
 * 查询佣金方案详情
 * @see https://api-doc.cxsport.net/#/view/B2lGyVmz
 */
export const reqApiAgentBetStationCommissionConfigQueryCfgDetailByCfgIdCfgId = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_BETSTATIONCOMMISSIONCONFIG_QUERYCFGDETAILBYCFGID_CFGID.REQ,
): Promise<OK_API_AGENT_BETSTATIONCOMMISSIONCONFIG_QUERYCFGDETAILBYCFGID_CFGID.RES> {
  const { cfgId } = params || {}
  return (this?.instance || AgentAPI).get(`/api/agent/betStationCommissionConfig/queryCfgDetailByCfgId/${cfgId}`, { ...this, params })
}

/**
 * <p>绑定手机号码</p>
 * @see https://api-doc.cxsport.net/#/view/pX9gb9v2
 */
export const reqApiAgentCenterBindPhone = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_CENTER_BINDPHONE.REQ): Promise<OK_API_AGENT_CENTER_BINDPHONE.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/center/bindPhone`, params, this || undefined)
}

/**
 * <p>拒绝</p>
 * @see https://api-doc.cxsport.net/#/view/Pzmeyqlz
 */
export const reqApiAgentUserKycReject = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_USERKYC_REJECT.REQ): Promise<OK_API_AGENT_USERKYC_REJECT.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/userKyc/reject`, params, this || undefined)
}

/**
 * 结算
 * @see https://api-doc.cxsport.net/#/view/42G5QMJX
 */
export const reqApiAgentAgentCommissionBetReportSettle = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_AGENTCOMMISSIONBETREPORT_SETTLE.REQ,
): Promise<OK_API_AGENT_AGENTCOMMISSIONBETREPORT_SETTLE.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/agentCommissionBetReport/settle`, params, this || undefined)
}

/**
 * 修改流水佣金方案配置
 * @see https://api-doc.cxsport.net/#/view/r2jZ0g12
 */
export const reqApiAgentAgentEarningsBetConfigSave = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_AGENTEARNINGSBETCONFIG_SAVE.REQ,
): Promise<OK_API_AGENT_AGENTEARNINGSBETCONFIG_SAVE.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/agentEarningsBetConfig/save`, params, this || undefined)
}

/**
 * 结算
 * @see https://api-doc.cxsport.net/#/view/qXBRgexX
 */
export const reqApiAgentAgentCommissionProfitReportSettle = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_AGENTCOMMISSIONPROFITREPORT_SETTLE.REQ,
): Promise<OK_API_AGENT_AGENTCOMMISSIONPROFITREPORT_SETTLE.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/agentCommissionProfitReport/settle`, params, this || undefined)
}

/**
 * 修改负盈利佣金方案配置
 * @see https://api-doc.cxsport.net/#/view/VXEyVYyX
 */
export const reqApiAgentAgentEarningsProfitConfigSave = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_AGENTEARNINGSPROFITCONFIG_SAVE.REQ,
): Promise<OK_API_AGENT_AGENTEARNINGSPROFITCONFIG_SAVE.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/agentEarningsProfitConfig/save`, params, this || undefined)
}

/**
 * 根据国家取得币种
 * @see https://api-doc.cxsport.net/#/view/pX9gB42r
 */
export const reqApiAgentCurrencyQueryByNationNationCode = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_CURRENCY_QUERYBYNATION_NATIONCODE.REQ,
): Promise<OK_API_AGENT_CURRENCY_QUERYBYNATION_NATIONCODE.RES> {
  const { nationCode } = params || {}
  return (this?.instance || AgentAPI).get(`/api/agent/currency/queryByNation/${nationCode}`, { ...this, params })
}

/**
 * 删除
 * @see https://api-doc.cxsport.net/#/view/JzA3bx8p
 */
export const reqApiAgentBettingstationsubDelId = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_BETTING_STATION_SUB_DEL_ID.REQ,
): Promise<OK_API_AGENT_BETTING_STATION_SUB_DEL_ID.RES> {
  const { id } = params || {}
  return (this?.instance || AgentAPI).get(`/api/agent/betting-station-sub/del/${id}`, { ...this, params })
}

/**
 * 代理交易类型
 * @see https://api-doc.cxsport.net/#/view/nzDOqNXp
 */
export const reqApiAgentFinanceRecordAgentTranTypes = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_FINANCERECORD_AGENTTRANTYPES.REQ,
): Promise<OK_API_AGENT_FINANCERECORD_AGENTTRANTYPES.RES> {
  return (this?.instance || AgentAPI).get(`/api/agent/financeRecord/agentTranTypes`, { ...this, params })
}

/**
 * 新增
 * @see https://api-doc.cxsport.net/#/view/ez7VjwXa
 */
export const reqApiAgentAgentRoleSave = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_AGENTROLE_SAVE.REQ): Promise<OK_API_AGENT_AGENTROLE_SAVE.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/agentRole/save`, params, this || undefined)
}

/**
 * <p>获取提款总额</p>
 * @see https://api-doc.cxsport.net/#/view/qXblpg2v
 */
export const reqApiAgentUserwithdrawStationstatistic = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_USER_WITHDRAW_STATIONSTATISTIC.REQ,
): Promise<OK_API_AGENT_USER_WITHDRAW_STATIONSTATISTIC.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/user-withdraw/stationstatistic`, params, this || undefined)
}

/**
 * <p>代理为直属会员充值</p>
 * @see https://api-doc.cxsport.net/#/view/nzdar02j
 */
export const reqApiAgentUserrechAgentRechForUser = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_USER_RECH_AGENTRECHFORUSER.REQ,
): Promise<OK_API_AGENT_USER_RECH_AGENTRECHFORUSER.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/user-rech/agentRechForUser`, params, this || undefined)
}

/**
 *
 * @see https://api-doc.cxsport.net/#/view/qXblGg2v
 */
export const reqApiAgentUserRebateListThirdUserId = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_USER_REBATE_LISTTHIRD_USERID.REQ,
): Promise<OK_API_AGENT_USER_REBATE_LISTTHIRD_USERID.RES> {
  const { userId } = params || {}
  return (this?.instance || AgentAPI).get(`/api/agent/user/rebate/listThird/${userId}`, { ...this, params })
}

/**
 * <p>统计游戏</p>
 * @see https://api-doc.cxsport.net/#/view/q2RevBzg
 */
export const reqApiAgentPlatformStationStatisticGameStatistics = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_PLATFORM_STATION_STATISTIC_GAMESTATISTICS.REQ,
): Promise<OK_API_AGENT_PLATFORM_STATION_STATISTIC_GAMESTATISTICS.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/platform/station/statistic/gameStatistics`, params, this || undefined)
}

/**
 * 是否启用验证码
 * @see https://api-doc.cxsport.net/#/view/ez7PgV2a
 */
export const reqApiAgentIndexValidcodeenable = async function (this: AxiosRequestConfig | void): Promise<OK_API_AGENT_INDEX_VALIDCODEENABLE.RES> {
  return (this?.instance || AgentAPI).get(`/api/agent/index/validcodeenable`, this || undefined)
}

/**
 * 保存三方开启状态
 * @see https://api-doc.cxsport.net/#/view/r2jA1nzG
 */
export const reqApiAgentThirdcustomconfigSaveOpenState = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_THIRD_CUSTOM_CONFIG_SAVEOPENSTATE.REQ,
): Promise<OK_API_AGENT_THIRD_CUSTOM_CONFIG_SAVEOPENSTATE.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/third-custom-config/saveOpenState`, params, this || undefined)
}

/**
 * 第三方游戏信息 游戏分类code
 * @see https://api-doc.cxsport.net/#/view/42GAWQXW
 */
export const reqApiAgentPlatformUserStatisticThirdgamesCode = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_PLATFORM_USER_STATISTIC_THIRDGAMES_CODE.REQ,
): Promise<OK_API_AGENT_PLATFORM_USER_STATISTIC_THIRDGAMES_CODE.RES> {
  const { code } = params || {}
  return (this?.instance || AgentAPI).get(`/api/agent/platform/user/statistic/thirdgames/${code}`, { ...this, params })
}

/**
 * 实名认证类型
 * @see https://api-doc.cxsport.net/#/view/N2elvwze
 */
export const reqApiAgentBettingstationQueryIdentityType = async function (this: AxiosRequestConfig | void): Promise<OK_API_AGENT_BETTING_STATION_QUERYIDENTITYTYPE.RES> {
  return (this?.instance || AgentAPI).get(`/api/agent/betting-station/queryIdentityType`, this || undefined)
}

/**
 *
 * @see https://api-doc.cxsport.net/#/view/K2ZOmd8v
 */
export const reqApiAgentUserSave = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_USER_SAVE.REQ): Promise<OK_API_AGENT_USER_SAVE.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/user/save`, params, this || undefined)
}

/**
 * 查看详情
 * @see https://api-doc.cxsport.net/#/view/pX9gbJa2
 */
export const reqApiAgentAgentEarningsConfigGetId = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_AGENTEARNINGSCONFIG_GET_ID.REQ,
): Promise<OK_API_AGENT_AGENTEARNINGSCONFIG_GET_ID.RES> {
  const { id } = params || {}
  return (this?.instance || AgentAPI).get(`/api/agent/agentEarningsConfig/get/${id}`, { ...this, params })
}

/**
 * 创建新佣金方案
 * @see https://api-doc.cxsport.net/#/view/aXYwyAJ2
 */
export const reqApiAgentBetStationCommissionConfigCreateCfg = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_BETSTATIONCOMMISSIONCONFIG_CREATECFG.REQ,
): Promise<OK_API_AGENT_BETSTATIONCOMMISSIONCONFIG_CREATECFG.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/betStationCommissionConfig/createCfg`, params, this || undefined)
}

/**
 * <p>补充材料</p>
 * @see https://api-doc.cxsport.net/#/view/N2eJyLx8
 */
export const reqApiAgentUserKycAdditionalReview = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_USERKYC_ADDITIONALREVIEW.REQ,
): Promise<OK_API_AGENT_USERKYC_ADDITIONALREVIEW.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/userKyc/additionalReview`, params, this || undefined)
}

/**
 * 佣金提款
 * @see https://api-doc.cxsport.net/#/view/NzvQyYqX
 */
export const reqApiAgentAgentwithdrawAddDraw = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_AGENTWITHDRAW_ADDDRAW.REQ): Promise<OK_API_AGENT_AGENTWITHDRAW_ADDDRAW.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/agentwithdraw/addDraw`, params, this || undefined)
}

/**
 * 重新审核
 * @see https://api-doc.cxsport.net/#/view/m8worbl8
 */
export const reqApiAgentAgentCommissionBetReportReAudit = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_AGENTCOMMISSIONBETREPORT_REAUDIT.REQ,
): Promise<OK_API_AGENT_AGENTCOMMISSIONBETREPORT_REAUDIT.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/agentCommissionBetReport/reAudit`, params, this || undefined)
}

/**
 * 删除流水佣金配置项
 * @see https://api-doc.cxsport.net/#/view/32QMkKG2
 */
export const reqApiAgentAgentEarningsBetConfigDelete = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_AGENTEARNINGSBETCONFIG_DELETE.REQ,
): Promise<OK_API_AGENT_AGENTEARNINGSBETCONFIG_DELETE.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/agentEarningsBetConfig/delete`, params, this || undefined)
}

/**
 * 重新审核
 * @see https://api-doc.cxsport.net/#/view/pX9W0wv2
 */
export const reqApiAgentAgentCommissionProfitReportReAudit = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_AGENTCOMMISSIONPROFITREPORT_REAUDIT.REQ,
): Promise<OK_API_AGENT_AGENTCOMMISSIONPROFITREPORT_REAUDIT.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/agentCommissionProfitReport/reAudit`, params, this || undefined)
}

/**
 * 删除负盈利佣金配置项
 * @see https://api-doc.cxsport.net/#/view/r2jAYnqz
 */
export const reqApiAgentAgentEarningsProfitConfigDelete = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_AGENTEARNINGSPROFITCONFIG_DELETE.REQ,
): Promise<OK_API_AGENT_AGENTEARNINGSPROFITCONFIG_DELETE.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/agentEarningsProfitConfig/delete`, params, this || undefined)
}

/**
 * 查看
 * @see https://api-doc.cxsport.net/#/view/d2q0MJzw
 */
export const reqApiAgentBettingstationsubGetId = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_BETTING_STATION_SUB_GET_ID.REQ,
): Promise<OK_API_AGENT_BETTING_STATION_SUB_GET_ID.RES> {
  const { id } = params || {}
  return (this?.instance || AgentAPI).get(`/api/agent/betting-station-sub/get/${id}`, { ...this, params })
}

/**
 * 删除
 * @see https://api-doc.cxsport.net/#/view/NzvQvwXD
 */
export const reqApiAgentAgentRoleDelId = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_AGENTROLE_DEL_ID.REQ): Promise<OK_API_AGENT_AGENTROLE_DEL_ID.RES> {
  const { id } = params || {}
  return (this?.instance || AgentAPI).get(`/api/agent/agentRole/del/${id}`, { ...this, params })
}

/**
 * <p>投注站为直属代理充值</p>
 * @see https://api-doc.cxsport.net/#/view/e24ZdeXL
 */
export const reqApiAgentUserrechStationRechForAgent = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_USER_RECH_STATIONRECHFORAGENT.REQ,
): Promise<OK_API_AGENT_USER_RECH_STATIONRECHFORAGENT.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/user-rech/stationRechForAgent`, params, this || undefined)
}

/**
 * <p>按月统计存提款</p>
 * @see https://api-doc.cxsport.net/#/view/nzDRqZ8p
 */
export const reqApiAgentPlatformStationStatisticRechDraw = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_PLATFORM_STATION_STATISTIC_RECHDRAW.REQ,
): Promise<OK_API_AGENT_PLATFORM_STATION_STATISTIC_RECHDRAW.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/platform/station/statistic/rechDraw`, params, this || undefined)
}

/**
 * 退出
 * @see https://api-doc.cxsport.net/#/view/NzvBnBzD
 */
export const reqApiAgentIndexLogout = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_INDEX_LOGOUT.REQ): Promise<OK_API_AGENT_INDEX_LOGOUT.RES> {
  return (this?.instance || AgentAPI).get(`/api/agent/index/logout`, { ...this, params })
}

/**
 *
 * @see https://api-doc.cxsport.net/#/view/m8wBx42k
 */
export const reqApiAgentPlatformUserStatisticQueryFirmCodes = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_PLATFORM_USER_STATISTIC_QUERYFIRMCODES.REQ,
): Promise<OK_API_AGENT_PLATFORM_USER_STATISTIC_QUERYFIRMCODES.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/platform/user/statistic/queryFirmCodes`, params, this || undefined)
}

/**
 * 实名验证审核
 * @see https://api-doc.cxsport.net/#/view/wXnp4Y29
 */
export const reqApiAgentBettingstationReviewRealNameVerify = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_BETTING_STATION_REVIEWREALNAMEVERIFY.REQ,
): Promise<OK_API_AGENT_BETTING_STATION_REVIEWREALNAMEVERIFY.RES> {
  return (this?.instance || AgentAPI).get(`/api/agent/betting-station/reviewRealNameVerify`, { ...this, params })
}

/**
 *
 * @see https://api-doc.cxsport.net/#/view/bXKkQaX7
 */
export const reqApiAgentUserSaveCreditVip = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_USER_SAVECREDITVIP.REQ): Promise<OK_API_AGENT_USER_SAVECREDITVIP.RES> {
  return (this?.instance || AgentAPI).get(`/api/agent/user/saveCreditVip`, { ...this, params })
}

/**
 * 删除佣金配置项
 * @see https://api-doc.cxsport.net/#/view/wXPwOP38
 */
export const reqApiAgentAgentEarningsConfigDeleteId = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_AGENTEARNINGSCONFIG_DELETE_ID.REQ,
): Promise<OK_API_AGENT_AGENTEARNINGSCONFIG_DELETE_ID.RES> {
  const { id } = params || {}
  return (this?.instance || AgentAPI).get(`/api/agent/agentEarningsConfig/delete/${id}`, { ...this, params })
}

/**
 * 更新佣金方案详情
 * @see https://api-doc.cxsport.net/#/view/Q2V0yrJX
 */
export const reqApiAgentBetStationCommissionConfigUpdateCfg = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_BETSTATIONCOMMISSIONCONFIG_UPDATECFG.REQ,
): Promise<OK_API_AGENT_BETSTATIONCOMMISSIONCONFIG_UPDATECFG.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/betStationCommissionConfig/updateCfg`, params, this || undefined)
}

/**
 * <p>复审通过</p>
 * @see https://api-doc.cxsport.net/#/view/wXnky3mz
 */
export const reqApiAgentUserKycPassReview = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_USERKYC_PASSREVIEW.REQ): Promise<OK_API_AGENT_USERKYC_PASSREVIEW.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/userKyc/passReview`, params, this || undefined)
}

/**
 * 获取所有银行信息
 * @see https://api-doc.cxsport.net/#/view/a26oGwl8
 */
export const reqApiAgentAgentwithdrawBankInfo = async function (this: AxiosRequestConfig | void): Promise<OK_API_AGENT_AGENTWITHDRAW_BANKINFO.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/agentwithdraw/bankInfo`, null, this || undefined)
}

/**
 * 取消
 * @see https://api-doc.cxsport.net/#/view/E8rdPLYz
 */
export const reqApiAgentAgentCommissionBetReportCancel = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_AGENTCOMMISSIONBETREPORT_CANCEL.REQ,
): Promise<OK_API_AGENT_AGENTCOMMISSIONBETREPORT_CANCEL.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/agentCommissionBetReport/cancel`, params, this || undefined)
}

/**
 * 通过代理ID查询返回包含当前所在的配置租和佣金配置列表
 * @see https://api-doc.cxsport.net/#/view/qXBZ0bxX
 */
export const reqApiAgentAgentEarningsBetConfigQueryCfgListByAgentId = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_AGENTEARNINGSBETCONFIG_QUERYCFGLISTBYAGENTID.REQ,
): Promise<OK_API_AGENT_AGENTEARNINGSBETCONFIG_QUERYCFGLISTBYAGENTID.RES> {
  return (this?.instance || AgentAPI).get(`/api/agent/agentEarningsBetConfig/queryCfgListByAgentId`, { ...this, params })
}

/**
 * 取消
 * @see https://api-doc.cxsport.net/#/view/wXPdmQjX
 */
export const reqApiAgentAgentCommissionProfitReportCancel = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_AGENTCOMMISSIONPROFITREPORT_CANCEL.REQ,
): Promise<OK_API_AGENT_AGENTCOMMISSIONPROFITREPORT_CANCEL.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/agentCommissionProfitReport/cancel`, params, this || undefined)
}

/**
 * 提款确定通过
 * @see https://api-doc.cxsport.net/#/view/NzvaLxBX
 */
export const reqApiAgentUserwithdrawConfirm = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_USER_WITHDRAW_CONFIRM.REQ): Promise<OK_API_AGENT_USER_WITHDRAW_CONFIRM.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/user-withdraw/confirm`, params, this || undefined)
}

/**
 * 更新
 * @see https://api-doc.cxsport.net/#/view/a26oEN8l
 */
export const reqApiAgentAgentRoleUpdate = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_AGENTROLE_UPDATE.REQ): Promise<OK_API_AGENT_AGENTROLE_UPDATE.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/agentRole/update`, params, this || undefined)
}

/**
 * <p>提款不通过</p>
 * @see https://api-doc.cxsport.net/#/view/JzAVdY2p
 */
export const reqApiAgentUserwithdrawReject = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_USER_WITHDRAW_REJECT.REQ): Promise<OK_API_AGENT_USER_WITHDRAW_REJECT.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/user-withdraw/reject`, params, this || undefined)
}

/**
 *
 * @see https://api-doc.cxsport.net/#/view/VXEy3WXv
 */
export const reqApiAgentUserrechQuerystatistic = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_USER_RECH_QUERYSTATISTIC.REQ,
): Promise<OK_API_AGENT_USER_RECH_QUERYSTATISTIC.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/user-rech/querystatistic`, params, this || undefined)
}

/**
 * 获取支持的语言
 * @see https://api-doc.cxsport.net/#/view/a2696Azl
 */
export const reqApiAgentIndexLanguage = async function (this: AxiosRequestConfig | void): Promise<OK_API_AGENT_INDEX_LANGUAGE.RES> {
  return (this?.instance || AgentAPI).get(`/api/agent/index/language`, this || undefined)
}

/**
 * <p>投注站报表 - 平台日报</p>
 * @see https://api-doc.cxsport.net/#/view/JzAVgM2p
 */
export const reqApiAgentPlatformUserStatisticAgentDailyReport = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_PLATFORM_USER_STATISTIC_AGENTDAILYREPORT.REQ): Promise<any> {
  return (this?.instance || AgentAPI).post(`/api/agent/platform/user/statistic/agentDailyReport`, params, this || undefined)
}

/**
 *
 * @see https://api-doc.cxsport.net/#/view/ez7PW32a
 */
export const reqApiAgentUserUpdatepwd = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_USER_UPDATEPWD.REQ): Promise<OK_API_AGENT_USER_UPDATEPWD.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/user/updatepwd`, params, this || undefined)
}

/**
 * 通过代理ID查询返回包含当前所在的配置租和佣金配置列表
 * @see https://api-doc.cxsport.net/#/view/7zLOgjdX
 */
export const reqApiAgentAgentEarningsConfigQueryCfgListByAgentIdAgentId = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_AGENTEARNINGSCONFIG_QUERYCFGLISTBYAGENTID_AGENTID.REQ,
): Promise<OK_API_AGENT_AGENTEARNINGSCONFIG_QUERYCFGLISTBYAGENTID_AGENTID.RES> {
  const { agentId } = params || {}
  return (this?.instance || AgentAPI).get(`/api/agent/agentEarningsConfig/queryCfgListByAgentId/${agentId}`, { ...this, params })
}

/**
 * 删除佣金配置项
 * @see https://api-doc.cxsport.net/#/view/kXOgVBbX
 */
export const reqApiAgentBetStationCommissionConfigDeleteCfgCfgId = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_BETSTATIONCOMMISSIONCONFIG_DELETECFG_CFGID.REQ,
): Promise<OK_API_AGENT_BETSTATIONCOMMISSIONCONFIG_DELETECFG_CFGID.RES> {
  const { cfgId } = params || {}
  return (this?.instance || AgentAPI).get(`/api/agent/betStationCommissionConfig/deleteCfg/${cfgId}`, { ...this, params })
}

/**
 * <p>拒绝复审</p>
 * @see https://api-doc.cxsport.net/#/view/d8xVpvlz
 */
export const reqApiAgentUserKycRejectReview = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_USERKYC_REJECTREVIEW.REQ): Promise<OK_API_AGENT_USERKYC_REJECTREVIEW.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/userKyc/rejectReview`, params, this || undefined)
}

/**
 * 获取当前用户绑定的银行卡
 * @see https://api-doc.cxsport.net/#/view/BXgRyGL8
 */
export const reqApiAgentAgentwithdrawUserBank = async function (this: AxiosRequestConfig | void): Promise<OK_API_AGENT_AGENTWITHDRAW_USERBANK.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/agentwithdraw/userBank`, null, this || undefined)
}

/**
 * <p>实名验证审核 前台会员提交实名认证时, 要可在投注站后台通过该会员的KYC认证, 通过之后不需平台后台复审, 即可视为认证完成</p>
 * @see https://api-doc.cxsport.net/#/view/r2jZy5q2
 */
export const reqApiAgentBettingstationReviewRealNameVerifyBettingStation = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_BETTING_STATION_REVIEWREALNAMEVERIFYBETTINGSTATION.REQ,
): Promise<OK_API_AGENT_BETTING_STATION_REVIEWREALNAMEVERIFYBETTINGSTATION.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/betting-station/reviewRealNameVerifyBettingStation`, params, this || undefined)
}

/**
 * 重新计算负盈利佣金
 * @see https://api-doc.cxsport.net/#/view/VXEyyPWX
 */
export const reqApiAgentAgentCommissionProfitReportCalculateCommission = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_AGENTCOMMISSIONPROFITREPORT_CALCULATECOMMISSION.REQ,
): Promise<OK_API_AGENT_AGENTCOMMISSIONPROFITREPORT_CALCULATECOMMISSION.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/agentCommissionProfitReport/calculateCommission`, params, this || undefined)
}

/**
 * 获取投注站下的所有角色
 * @see https://api-doc.cxsport.net/#/view/BXgRAe8G
 */
export const reqApiAgentAgentRoleAll = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_AGENTROLE_ALL.REQ): Promise<OK_API_AGENT_AGENTROLE_ALL.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/agentRole/all`, params, this || undefined)
}

/**
 * 审核通过
 * @see https://api-doc.cxsport.net/#/view/d2q4b7zw
 */
export const reqApiAgentUserwithdrawAuditPass = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_USER_WITHDRAW_AUDITPASS.REQ): Promise<OK_API_AGENT_USER_WITHDRAW_AUDITPASS.RES> {
  return (this?.instance || AgentAPI).get(`/api/agent/user-withdraw/auditPass`, { ...this, params })
}

/**
 * 获取系统配置
 * @see https://api-doc.cxsport.net/#/view/BXgv9K8G
 */
export const reqApiAgentIndexConfig = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_INDEX_CONFIG.REQ): Promise<OK_API_AGENT_INDEX_CONFIG.RES> {
  return (this?.instance || AgentAPI).get(`/api/agent/index/config`, { ...this, params })
}

/**
 * <p>代理报表 - 体育报表</p>
 * @see https://api-doc.cxsport.net/#/view/E8rq3620
 */
export const reqApiAgentPlatformUserStatisticAgentreport = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_PLATFORM_USER_STATISTIC_AGENTREPORT.REQ,
): Promise<OK_API_AGENT_PLATFORM_USER_STATISTIC_AGENTREPORT.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/platform/user/statistic/agentreport`, params, this || undefined)
}

/**
 * <p>拒绝实名验证</p>
 * @see https://api-doc.cxsport.net/#/view/d8x9wPXg
 */
export const reqApiAgentBettingstationRejectRealNameVerify = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_BETTING_STATION_REJECTREALNAMEVERIFY.REQ,
): Promise<OK_API_AGENT_BETTING_STATION_REJECTREALNAMEVERIFY.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/betting-station/rejectRealNameVerify`, params, this || undefined)
}

/**
 *
 * @see https://api-doc.cxsport.net/#/view/NzvB15zD
 */
export const reqApiAgentUserUpdatefundpwd = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_USER_UPDATEFUNDPWD.REQ): Promise<OK_API_AGENT_USER_UPDATEFUNDPWD.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/user/updatefundpwd`, params, this || undefined)
}

/**
 * 代理使用的佣金方案更新
 * @see https://api-doc.cxsport.net/#/view/P81KBn6z
 */
export const reqApiAgentAgentEarningsConfigEditAgentCommissionPlan = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_AGENTEARNINGSCONFIG_EDITAGENTCOMMISSIONPLAN.REQ,
): Promise<OK_API_AGENT_AGENTEARNINGSCONFIG_EDITAGENTCOMMISSIONPLAN.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/agentEarningsConfig/editAgentCommissionPlan`, params, this || undefined)
}

/**
 * 代理使用的佣金方案更新
 * @see https://api-doc.cxsport.net/#/view/a85a1DJ8
 */
export const reqApiAgentBetStationCommissionConfigEditAgentCommissionPlan = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_BETSTATIONCOMMISSIONCONFIG_EDITAGENTCOMMISSIONPLAN.REQ,
): Promise<OK_API_AGENT_BETSTATIONCOMMISSIONCONFIG_EDITAGENTCOMMISSIONPLAN.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/betStationCommissionConfig/editAgentCommissionPlan`, params, this || undefined)
}

/**
 * 新增或修改当前用户点银行卡，因为代理只能绑定一张，所以有就更新，没有新增
 * @see https://api-doc.cxsport.net/#/view/B2lGyAVz
 */
export const reqApiAgentAgentwithdrawSaveUserBank = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_AGENTWITHDRAW_SAVEUSERBANK.REQ,
): Promise<OK_API_AGENT_AGENTWITHDRAW_SAVEUSERBANK.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/agentwithdraw/saveUserBank`, params, this || undefined)
}

/**
 * 获取提现稽核资料
 * @see https://api-doc.cxsport.net/#/view/Wz35nn8R
 */
export const reqApiAgentUserwithdrawGetUwCheckUserId = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_USER_WITHDRAW_GETUWCHECK_USERID.REQ,
): Promise<OK_API_AGENT_USER_WITHDRAW_GETUWCHECK_USERID.RES> {
  const { userId } = params || {}
  return (this?.instance || AgentAPI).get(`/api/agent/user-withdraw/getUwCheck/${userId}`, { ...this, params })
}

/**
 * <p>获取平台配置</p>
 * @see https://api-doc.cxsport.net/#/view/B2lJwZXD
 */
export const reqApiAgentIndexGetPlatformConfig = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_INDEX_GETPLATFORMCONFIG.REQ,
): Promise<OK_API_AGENT_INDEX_GETPLATFORMCONFIG.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/index/getPlatformConfig`, params, this || undefined)
}

/**
 * 代理报表 - 第三方游戏报表
 * @see https://api-doc.cxsport.net/#/view/qXbl4x2v
 */
export const reqApiAgentPlatformUserStatisticThirdreport = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_PLATFORM_USER_STATISTIC_THIRDREPORT.REQ,
): Promise<OK_API_AGENT_PLATFORM_USER_STATISTIC_THIRDREPORT.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/platform/user/statistic/thirdreport`, params, this || undefined)
}

/**
 *
 * @see https://api-doc.cxsport.net/#/view/a269nkzl
 */
export const reqApiAgentUserQueryuserbank = async function (this: AxiosRequestConfig | void): Promise<OK_API_AGENT_USER_QUERYUSERBANK.RES> {
  return (this?.instance || AgentAPI).get(`/api/agent/user/queryuserbank`, this || undefined)
}

/**
 * <p>投注站修改资金的可用额度</p>
 * @see https://api-doc.cxsport.net/#/view/kXOpZ6zD
 */
export const reqApiAgentBettingstationUpdateQuota = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_BETTING_STATION_UPDATEQUOTA.REQ,
): Promise<OK_API_AGENT_BETTING_STATION_UPDATEQUOTA.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/betting-station/updateQuota`, params, this || undefined)
}

/**
 *
 * @see https://api-doc.cxsport.net/#/view/42G5Zp3X
 */
export const reqApiAgentAgentEarningsConfigGetFee = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_AGENTEARNINGSCONFIG_GETFEE.REQ,
): Promise<OK_API_AGENT_AGENTEARNINGSCONFIG_GETFEE.RES> {
  return (this?.instance || AgentAPI).get(`/api/agent/agentEarningsConfig/getFee`, { ...this, params })
}

/**
 * 投注站为直属代理提款
 * @see https://api-doc.cxsport.net/#/view/VzNpbo8Y
 */
export const reqApiAgentUserwithdrawStationWithdrawForAgent = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_USER_WITHDRAW_STATIONWITHDRAWFORAGENT.REQ,
): Promise<OK_API_AGENT_USER_WITHDRAW_STATIONWITHDRAWFORAGENT.RES> {
  return (this?.instance || AgentAPI).get(`/api/agent/user-withdraw/stationWithdrawForAgent`, { ...this, params })
}

/**
 * 是否需要google验证码
 * @see https://api-doc.cxsport.net/#/view/aXYO7R2r
 */
export const reqApiAgentIndexNeedGoogleCode = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_INDEX_NEEDGOOGLECODE.REQ): Promise<OK_API_AGENT_INDEX_NEEDGOOGLECODE.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/index/needGoogleCode`, params, this || undefined)
}

/**
 *
 * @see https://api-doc.cxsport.net/#/view/BXgvWE8G
 */
export const reqApiAgentUserAdduserbank = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_USER_ADDUSERBANK.REQ): Promise<OK_API_AGENT_USER_ADDUSERBANK.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/user/adduserbank`, params, this || undefined)
}

/**
 *
 * @see https://api-doc.cxsport.net/#/view/pX9gbkv2
 */
export const reqApiAgentPlatformUserStatisticExportThirdReport = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_PLATFORM_USER_STATISTIC_EXPORTTHIRDREPORT.REQ,
): Promise<OK_API_AGENT_PLATFORM_USER_STATISTIC_EXPORTTHIRDREPORT.RES> {
  return (this?.instance || AgentAPI).get(`/api/agent/platform/user/statistic/exportThirdReport`, { ...this, params })
}

/**
 *
 * @see https://api-doc.cxsport.net/#/view/pX9gbdM2
 */
export const reqApiAgentBettingstationQuerySalarySource = async function (this: AxiosRequestConfig | void): Promise<OK_API_AGENT_BETTING_STATION_QUERYSALARYSOURCE.RES> {
  return (this?.instance || AgentAPI).get(`/api/agent/betting-station/querySalarySource`, this || undefined)
}

/**
 * 新佣金方案-直属下级代理-代理可使用的佣金配置列表(负盈利和流水)
 * @see https://api-doc.cxsport.net/#/view/P81Kx0wz
 */
export const reqApiAgentAgentEarningsConfigQueryCfgListByAgentId = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_AGENTEARNINGSCONFIG_QUERYCFGLISTBYAGENTID.REQ,
): Promise<OK_API_AGENT_AGENTEARNINGSCONFIG_QUERYCFGLISTBYAGENTID.RES> {
  return (this?.instance || AgentAPI).get(`/api/agent/agentEarningsConfig/queryCfgListByAgentId`, { ...this, params })
}

/**
 * <p>锁定</p>
 * @see https://api-doc.cxsport.net/#/view/PzmA1rzJ
 */
export const reqApiAgentUserwithdrawLock = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_USER_WITHDRAW_LOCK.REQ): Promise<OK_API_AGENT_USER_WITHDRAW_LOCK.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/user-withdraw/lock`, params, this || undefined)
}

/**
 * <p>代理报表 - 资金报表</p>
 * @see https://api-doc.cxsport.net/#/view/L2kZp7zP
 */
export const reqApiAgentPlatformUserStatisticAgentFundsReport = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_PLATFORM_USER_STATISTIC_AGENTFUNDSREPORT.REQ,
): Promise<OK_API_AGENT_PLATFORM_USER_STATISTIC_AGENTFUNDSREPORT.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/platform/user/statistic/agentFundsReport`, params, this || undefined)
}

/**
 *
 * @see https://api-doc.cxsport.net/#/view/B2lJWdXD
 */
export const reqApiAgentUserQueryusermoney = async function (this: AxiosRequestConfig | void): Promise<OK_API_AGENT_USER_QUERYUSERMONEY.RES> {
  return (this?.instance || AgentAPI).get(`/api/agent/user/queryusermoney`, this || undefined)
}

/**
 * 手机登陆
 * @see https://api-doc.cxsport.net/#/view/xXaZypAz
 */
export const reqApiAgentIndexPhoneLogin = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_INDEX_PHONELOGIN.REQ): Promise<OK_API_AGENT_INDEX_PHONELOGIN.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/index/phoneLogin`, params, this || undefined)
}

/**
 * 新佣金方案-直属下级代理-代理使用的佣金方案更新(负盈利和流水)
 * @see https://api-doc.cxsport.net/#/view/d8xV5Oxz
 */
export const reqApiAgentAgentEarningsConfigEditAgentCommissionPlanV2 = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_AGENTEARNINGSCONFIG_EDITAGENTCOMMISSIONPLANV2.REQ,
): Promise<OK_API_AGENT_AGENTEARNINGSCONFIG_EDITAGENTCOMMISSIONPLANV2.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/agentEarningsConfig/editAgentCommissionPlanV2`, params, this || undefined)
}

/**
 * 解锁
 * @see https://api-doc.cxsport.net/#/view/N2el4vze
 */
export const reqApiAgentUserwithdrawUnlock = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_USER_WITHDRAW_UNLOCK.REQ): Promise<OK_API_AGENT_USER_WITHDRAW_UNLOCK.RES> {
  return (this?.instance || AgentAPI).get(`/api/agent/user-withdraw/unlock`, { ...this, params })
}

/**
 *
 * @see https://api-doc.cxsport.net/#/view/aXYONZ2r
 */
export const reqApiAgentUserQueryuserinfo = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_USER_QUERYUSERINFO.REQ): Promise<OK_API_AGENT_USER_QUERYUSERINFO.RES> {
  return (this?.instance || AgentAPI).get(`/api/agent/user/queryuserinfo`, { ...this, params })
}

/**
 *
 * @see https://api-doc.cxsport.net/#/view/7zLOgLVX
 */
export const reqApiAgentPlatformUserStatisticExportAgentFundsReport = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_PLATFORM_USER_STATISTIC_EXPORTAGENTFUNDSREPORT.REQ,
): Promise<OK_API_AGENT_PLATFORM_USER_STATISTIC_EXPORTAGENTFUNDSREPORT.RES> {
  return (this?.instance || AgentAPI).get(`/api/agent/platform/user/statistic/exportAgentFundsReport`, { ...this, params })
}

/**
 *
 * @see https://api-doc.cxsport.net/#/view/Q2VLA6Xe
 */
export const reqApiAgentUserUpdateSubPwd = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_USER_UPDATESUBPWD.REQ): Promise<OK_API_AGENT_USER_UPDATESUBPWD.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/user/updateSubPwd`, params, this || undefined)
}

/**
 * <p>自动解锁，打开出款页面后不关闭的时候自动调用</p>
 * @see https://api-doc.cxsport.net/#/view/58ploG83
 */
export const reqApiAgentUserwithdrawAutoUnlock = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_USER_WITHDRAW_AUTOUNLOCK.REQ,
): Promise<OK_API_AGENT_USER_WITHDRAW_AUTOUNLOCK.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/user-withdraw/autoUnlock`, params, this || undefined)
}

/**
 *
 * @see https://api-doc.cxsport.net/#/view/kXO0L9zD
 */
export const reqApiAgentUserUpdateSubState = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_USER_UPDATESUBSTATE.REQ): Promise<OK_API_AGENT_USER_UPDATESUBSTATE.RES> {
  return (this?.instance || AgentAPI).post(`/api/agent/user/updateSubState`, params, this || undefined)
}

/**
 * 根据用户id查找，只有投注站才有权限查找
 * @see https://api-doc.cxsport.net/#/view/a85KeDzZ
 */
export const reqApiAgentUserGetByIdUserId = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_USER_GETBYID_USERID.REQ): Promise<OK_API_AGENT_USER_GETBYID_USERID.RES> {
  const { userId } = params || {}
  return (this?.instance || AgentAPI).get(`/api/agent/user/getById/${userId}`, { ...this, params })
}

/**
 *
 * @see https://api-doc.cxsport.net/#/view/xXajopzo
 */
export const reqApiAgentUserUpdateVerified = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_USER_UPDATEVERIFIED.REQ): Promise<OK_API_AGENT_USER_UPDATEVERIFIED.RES> {
  return (this?.instance || AgentAPI).get(`/api/agent/user/updateVerified`, { ...this, params })
}

/**
 *
 * @see https://api-doc.cxsport.net/#/view/V2Jbj92y
 */
export const reqApiAgentUserQuerytrantypesok9 = async function (this: AxiosRequestConfig | void): Promise<OK_API_AGENT_USER_QUERYTRANTYPESOK9.RES> {
  return (this?.instance || AgentAPI).get(`/api/agent/user/querytrantypesok9`, this || undefined)
}

/**
 *
 * @see https://api-doc.cxsport.net/#/view/L2yorOXm
 */
export const reqApiAgentUserQueryDownlineUserBill = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_USER_QUERYDOWNLINEUSERBILL.REQ,
): Promise<OK_API_AGENT_USER_QUERYDOWNLINEUSERBILL.RES> {
  return (this?.instance || AgentAPI).get(`/api/agent/user/queryDownlineUserBill`, { ...this, params })
}

/**
 *
 * @see https://api-doc.cxsport.net/#/view/mzWPqK2l
 */
export const reqApiAgentUserClearpasswrongtimesUserId = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_USER_CLEARPASSWRONGTIMES_USERID.REQ,
): Promise<OK_API_AGENT_USER_CLEARPASSWRONGTIMES_USERID.RES> {
  const { userId } = params || {}
  return (this?.instance || AgentAPI).get(`/api/agent/user/clearpasswrongtimes/${userId}`, { ...this, params })
}

/**
 *
 * @see https://api-doc.cxsport.net/#/view/58pdjE83
 */
export const reqApiAgentUserRefreshgooglekeyUserId = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_USER_REFRESHGOOGLEKEY_USERID.REQ,
): Promise<OK_API_AGENT_USER_REFRESHGOOGLEKEY_USERID.RES> {
  const { userId } = params || {}
  return (this?.instance || AgentAPI).get(`/api/agent/user/refreshgooglekey/${userId}`, { ...this, params })
}

/**
 * 导出资金明细
 * @see https://api-doc.cxsport.net/#/view/YX0dAkXx
 */
export const reqApiAgentUserExportuserbill = async function (this: AxiosRequestConfig | void, params?: OK_API_AGENT_USER_EXPORTUSERBILL.REQ): Promise<OK_API_AGENT_USER_EXPORTUSERBILL.RES> {
  return (this?.instance || AgentAPI).get(`/api/agent/user/exportuserbill`, { ...this, params })
}

/**
 * 查看密码错误次数
 * @see https://api-doc.cxsport.net/#/view/nzda7D2j
 */
export const reqApiAgentUserGetpasswrongtimesUserId = async function (
  this: AxiosRequestConfig | void,
  params?: OK_API_AGENT_USER_GETPASSWRONGTIMES_USERID.REQ,
): Promise<OK_API_AGENT_USER_GETPASSWRONGTIMES_USERID.RES> {
  const { userId } = params || {}
  return (this?.instance || AgentAPI).get(`/api/agent/user/getpasswrongtimes/${userId}`, { ...this, params })
}
